import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { NoteService } from './services/note.service';

export function provideOutlookNoteDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([NoteService]);
}
